var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('PageHeader'),_c('v-container',{staticStyle:{"margin":"0px","padding":"0px","width":"100%"},attrs:{"fluid":""}},[_c('div',{attrs:{"id":"nav"}},[_c('router-view')],1)]),_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }